export default __webpack_public_path__ + "static/media/bgpatern.d9092ba7.jpg";